import { render, staticRenderFns } from "./DisplayControl.vue?vue&type=template&id=21efad81&scoped=true&"
import script from "./DisplayControl.vue?vue&type=script&lang=js&"
export * from "./DisplayControl.vue?vue&type=script&lang=js&"
import style0 from "./DisplayControl.vue?vue&type=style&index=0&id=21efad81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21efad81",
  null
  
)

export default component.exports